import { ResponseTransformers } from '../types/transformers';
import { deserializeResponseBody } from './transformers/response';
import { TransformerSet } from './TransformerSet';

export const RESPONSE_TRANSFORMER_SET_MAP: Record<
  TransformerSet,
  ResponseTransformers
> = {
  [TransformerSet.Default]: [deserializeResponseBody(true)],
  [TransformerSet.PreserveKeys]: [deserializeResponseBody(false)],
};
